/* ============================================================
   AL MALEH HOUSE — First Access (lead capture)
   Shopify-native customer form; this script only adds:
   • the "Email | WhatsApp" toggle
   • per-form success/error display (Shopify shares one state across forms)
   • the popup (timing, 30-day snooze, never after sign-up or after joining on WhatsApp,
     closes itself 3 s after a successful sign-up)
   ============================================================ */
(function () {
  'use strict';

  var KEY_SIGNED   = 'amh-fa-signed-up';
  var KEY_SNOOZED  = 'amh-fa-dismissed-at';
  var KEY_STASH    = 'amh-fa-last-submit';
  var SNOOZE_MS    = 30 * 24 * 60 * 60 * 1000;
  var MIN_DELAY_MS = 5000;
  var TIMER_MS     = 25000;
  var SUCCESS_CLOSE_MS = 3000;

  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  function ssGet(k) { try { return JSON.parse(window.sessionStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function ssSet(k, v) { try { window.sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function ssDel(k) { try { window.sessionStorage.removeItem(k); } catch (e) {} }

  var wrappers = Array.prototype.slice.call(document.querySelectorAll('[data-first-access]'));
  if (!wrappers.length) return;

  /* ---------- which form was just submitted? ---------- */
  var hashId = '';
  try { hashId = decodeURIComponent((window.location.hash || '').slice(1)); } catch (e) {}
  var stash = ssGet(KEY_STASH);
  var postedId = /^FirstAccess-/.test(hashId) ? hashId : (stash && stash.formId) || '';

  /* ---------- per-form behaviour ---------- */
  wrappers.forEach(function (wrap) {
    var id      = wrap.getAttribute('data-form-id');
    var form    = wrap.querySelector('form');
    if (!form) return;
    var success = wrap.querySelector('[data-fa-success]');
    var error   = wrap.querySelector('[data-fa-error]');
    var email   = form.querySelector('input[name="contact[email]"]');
    var tabs    = Array.prototype.slice.call(wrap.querySelectorAll('[data-fa-tab]'));

    // "Email | WhatsApp" toggle (accessible tabs: click, arrow keys, Home/End)
    function select(name, focus) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-fa-tab') === name;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
        var p = document.getElementById(t.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
        if (on && focus) t.focus();
      });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t.getAttribute('data-fa-tab'), false); });
      t.addEventListener('keydown', function (e) {
        var j = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 :
                e.key === 'Home' ? 0 : e.key === 'End' ? tabs.length - 1 : null;
        if (j === null) return;
        e.preventDefault();
        select(tabs[(j + tabs.length) % tabs.length].getAttribute('data-fa-tab'), true);
      });
    });

    // Shopify renders the same success/error into every customer form — keep it only on ours
    if (id !== postedId) {
      if (success) success.parentNode.removeChild(success);
      if (error) error.parentNode.removeChild(error);
      success = error = null;
    }

    if (success) {
      wrap.classList.add('is-success');               // the thank-you replaces the form
      lsSet(KEY_SIGNED, String(Date.now()));
      ssDel(KEY_STASH);
    }
    if (error && stash && stash.formId === id && email && stash.email) email.value = stash.email;

    form.addEventListener('submit', function () {
      ssSet(KEY_STASH, { formId: id, email: email ? email.value.trim() : '' });
      wrap.classList.add('is-busy');
      // Shopify's captcha may hold the submission (or the visitor may close its challenge): never leave the button stuck
      setTimeout(function () { wrap.classList.remove('is-busy'); }, 8000);
    });
  });

  // Joining on WhatsApp counts as signed up (the popup will not show again)
  document.addEventListener('click', function (e) {
    if (e.target instanceof Element && e.target.closest('[data-fa-wa-join]')) {
      lsSet(KEY_SIGNED, String(Date.now()));
      var p = document.getElementById('FirstAccessPopup');
      if (p && p.classList.contains('is-open')) {
        setTimeout(function () { document.dispatchEvent(new CustomEvent('first-access:close')); }, 400);
      }
    }
  });

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) wrappers.forEach(function (w) { w.classList.remove('is-busy'); });
  });

  // Bring the submitted form into view below the fixed header
  function scrollToPosted() {
    var w = postedId && document.querySelector('[data-form-id="' + postedId + '"]');
    if (!w || w.closest('#FirstAccessPopup')) return;
    if (!w.querySelector('[data-fa-success], [data-fa-error]')) return;
    var hh = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--hh'), 10) || 80;
    var top = w.getBoundingClientRect().top + window.scrollY - hh - 24;
    window.scrollTo(0, Math.max(0, top));
  }
  if (postedId) window.addEventListener('load', function () { setTimeout(scrollToPosted, 60); });

  /* ---------- popup ---------- */
  var popup = document.getElementById('FirstAccessPopup');
  if (!popup) return;
  var panel = popup.querySelector('.fa-popup-panel');
  var lastFocus = null, shown = false;

  function isOpen() { return popup.classList.contains('is-open'); }
  function otherDialogOpen() {
    var html = document.documentElement;
    var menu = document.getElementById('MobileMenu');
    return html.classList.contains('enquiry-drawer-open') ||
      (menu && menu.getAttribute('aria-hidden') === 'false');
  }
  function open(force) {
    if (isOpen()) return;
    if (!force && otherDialogOpen()) { setTimeout(function () { open(false); }, 4000); return; }
    shown = true;
    lsSet(KEY_SNOOZED, String(Date.now()));          // "shows once" — snooze starts when shown
    lastFocus = document.activeElement;
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('fa-popup-open');
    panel.setAttribute('tabindex', '-1');
    setTimeout(function () { panel.focus({ preventScroll: true }); }, 30);
  }
  function close() {
    if (!isOpen()) return;
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('fa-popup-open');
    lsSet(KEY_SNOOZED, String(Date.now()));          // not again for 30 days
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  popup.addEventListener('click', function (e) {
    if (e.target instanceof Element && e.target.closest('[data-fa-close]')) { e.preventDefault(); close(); }
  });
  document.addEventListener('first-access:close', close);
  document.addEventListener('keydown', function (e) {
    if (!isOpen()) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab') {
      var f = Array.prototype.filter.call(
        panel.querySelectorAll('a[href], button, input:not([type="hidden"]):not([disabled])'),
        function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && (document.activeElement === f[0] || document.activeElement === panel)) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });

  // Coming back from a popup submission: show the result inside the popup
  var popupWrap = popup.querySelector('[data-first-access]');
  if (popupWrap && postedId === popupWrap.getAttribute('data-form-id') &&
      popupWrap.querySelector('[data-fa-success], [data-fa-error]')) {
    open(true);
    if (popupWrap.querySelector('[data-fa-success]')) setTimeout(close, SUCCESS_CLOSE_MS);
    return;
  }

  // Eligibility: never after sign-up; not within 30 days of the last showing/closing
  if (lsGet(KEY_SIGNED)) return;
  var snoozed = parseInt(lsGet(KEY_SNOOZED) || '0', 10);
  if (snoozed && Date.now() - snoozed < SNOOZE_MS) return;

  function elapsed() { return (window.performance && performance.now) ? performance.now() : 0; }
  function trigger() {
    if (shown) return;
    var wait = MIN_DELAY_MS - elapsed();             // never within the first 5 seconds
    if (wait > 0) { setTimeout(trigger, wait); return; }
    window.removeEventListener('scroll', onScroll);
    open(false);
  }
  function onScroll() {
    var max = document.documentElement.scrollHeight - window.innerHeight;
    if (max > 0 && window.scrollY / max >= 0.5) trigger();
  }
  setTimeout(trigger, Math.max(0, TIMER_MS - elapsed()));
  window.addEventListener('scroll', onScroll, { passive: true });
})();
